import React, { Fragment, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import Grid from '@mui/material/Grid2';
import {
  Tooltip,
  IconButton,
  Popover,
  InputAdornment,
  Button,
  TextField,
} from '@mui/material';
import MoneyIcon from '@mui/icons-material/Money';
import CloseIcon from '@mui/icons-material/Close';
import { zIndexValues } from 'utils/styles';

const propTypes = {
  table: PropTypes.object.isRequired,
  refreshTableData: PropTypes.func.isRequired,
  updateStatus: PropTypes.func.isRequired,
};

const SelectFeeAdjustment = ({ table, refreshTableData, updateStatus }) => {
  const [newValue, setNewValue] = useState();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const anchorEl = useRef(null);

  const handleIconButtonClick = (event) => {
    anchorEl.current = event.currentTarget;
    setPopoverOpen(true);
  };

  const handlePopoverClose = () => {
    setPopoverOpen(false);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    // Only set if value is empty or a valid number
    if (value === '' || !isNaN(value)) {
      // @ts-ignore
      setNewValue(Number(value));
    }
  };

  const handleApply = () => {
    const selectedRows = table
      .getFilteredSelectedRowModel()
      .rows.map((row) => row.original);

    const newData = table.getRowModel().rows.map((row) => row.original);
    const issueIds = selectedRows.map((row) => row.issueTitle);
    issueIds.forEach((issueId) => {
      const currentIssue = newData.find((row) => row.issueTitle === issueId);
      // Check if the currentIssue is a bill or a wage
      const isBill = currentIssue.view.billId !== undefined;
      const id = isBill ? currentIssue.view.billId : currentIssue.view.wageId;
      const data = isBill ? { newFee: newValue } : { newWage: newValue };
      updateStatus(id, data);
    });
    refreshTableData();
    table.resetRowSelection();
  };

  return (
    <Fragment>
      {/* Button */}
      <Tooltip
        title={intl.get(
          'billing_for_received_cases_toolbar_select_tooltip_fee_adjustment'
        )}>
        <IconButton
          onClick={(event) => {
            handleIconButtonClick(event);
          }}>
          <MoneyIcon />
        </IconButton>
      </Tooltip>
      {/* The actual popover */}
      <Popover
        elevation={2}
        open={popoverOpen}
        onClose={handlePopoverClose}
        anchorEl={anchorEl.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}>
        <IconButton
          aria-label="Close"
          onClick={handlePopoverClose}
          style={{
            position: 'absolute',
            top: '4px',
            right: '4px',
            zIndex: zIndexValues.popover,
          }}>
          <CloseIcon />
        </IconButton>
        <Grid
          container
          sx={{
            margin: 3,
            paddingTop: 1,
            paddingLeft: 1,
            paddingRight: 1,
            width: '320px',
          }}>
          <Grid size={9}>
            <TextField
              label={intl.get(
                'billing_for_received_cases_toolbar_select_input_label_new_price'
              )}
              variant="outlined"
              size="small"
              type="number"
              // TODO Add currency symbol depending on the locale
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">￥</InputAdornment>
                  ),
                },
                htmlInput: {
                  min: 0, // Ensure `min` is passed to the underlying HTML <input>
                },
              }}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={3}>
            <Button
              size="medium"
              variant="contained"
              color="primary"
              onClick={handleApply}>
              {intl.get('paid_wage_toolbar_select_button_adjust_wage')}
            </Button>
          </Grid>
        </Grid>
      </Popover>
    </Fragment>
  );
};

SelectFeeAdjustment.propTypes = propTypes;

export default SelectFeeAdjustment;
